/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface DeckCreateUserRequest {
  first_name?: string;
  last_name?: string;
  email: string;
  pnr?: string | null;
  d_number?: string | null;
  utl?: string | null;
}
